module.exports = __webpack_public_path__ + "img/five05.4d5b4e7f.png";